import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Rocket, X } from "lucide-react";
import { api } from "../lib/api";

/**
 * Floating CTA persistent nell'angolo in basso a destra della demo.
 * Visibile solo quando `league.plan === "demo"`. Dismissible per sessione,
 * ricompare al reload della pagina se non nascosto con "Non ora".
 */
export default function DemoFloatingCTA({ enabled }) {
  const [dismissed, setDismissed] = useState(false);
  const [pricing, setPricing] = useState(null);

  useEffect(() => {
    if (!enabled) return;
    if (sessionStorage.getItem("demo_cta_dismissed")) {
      setDismissed(true);
      return;
    }
    api.get("/pricing/public").then((r) => setPricing(r.data)).catch(() => {});
  }, [enabled]);

  function dismiss() {
    sessionStorage.setItem("demo_cta_dismissed", "1");
    setDismissed(true);
  }

  if (!enabled || dismissed) return null;

  const price = pricing?.amount_eur ?? 69;
  const hasDiscount = pricing?.is_discount;

  return (
    <div
      data-testid="demo-floating-cta"
      className="fixed bottom-4 right-4 z-[45] max-w-[320px] animate-in slide-in-from-bottom-4"
    >
      <div className="relative rounded-2xl bg-gradient-to-br from-emerald-500 to-emerald-600 text-slate-950 shadow-[0_10px_40px_rgba(16,185,129,0.5)] p-4 pr-8 border border-emerald-300/50">
        <button
          onClick={dismiss}
          data-testid="demo-cta-dismiss"
          aria-label="Nascondi"
          className="absolute top-2 right-2 text-slate-950/60 hover:text-slate-950 transition-colors"
        >
          <X size={14}/>
        </button>
        <div className="flex items-start gap-3">
          <div className="shrink-0 w-9 h-9 rounded-lg bg-slate-950/20 flex items-center justify-center">
            <Rocket size={18} strokeWidth={2.5}/>
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-[10px] uppercase tracking-widest font-black opacity-80">
              Ti piace? Passa alla vera
            </div>
            <div className="mt-0.5 font-black text-sm leading-tight">
              Attiva la tua lega — <span className="font-mono">{price} €</span>
              {hasDiscount && (
                <span className="line-through opacity-60 text-xs font-normal ml-1">69€</span>
              )}
            </div>
            <Link
              to="/register"
              data-testid="demo-cta-link"
              className="mt-2 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-slate-950 text-emerald-400 hover:bg-slate-800 text-xs font-black uppercase tracking-widest transition-colors"
            >
              Crea la mia lega →
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
